import { PriceLookupKeyEnum, TierLookupKeyEnum } from "~/api/generated/model";

export const PRICE_LOOKUP_KEYS: Record<TierLookupKeyEnum, PriceLookupKeyEnum> =
  {
    [TierLookupKeyEnum.Basic]: PriceLookupKeyEnum.BasicStandardPrice,
    [TierLookupKeyEnum.Premium]: PriceLookupKeyEnum.PremiumStandardPrice,
    [TierLookupKeyEnum.Analyse]: PriceLookupKeyEnum.AnalyseStandardPrice,
  };

export const PRODUCT_SUBSCRIPTIONS: Record<
  TierLookupKeyEnum,
  { name: string; route: "/ejendomstjek" | "/byggeradar" | "/rapporter" }
> = {
  [TierLookupKeyEnum.Basic]: {
    name: "Ejendomstjek",
    route: "/ejendomstjek",
  },
  [TierLookupKeyEnum.Premium]: { name: "ByggeRadar", route: "/byggeradar" },
  [TierLookupKeyEnum.Analyse]: { name: "Analyse", route: "/rapporter" },
};
